import $ from 'jquery/src/jquery'
import gsap from "gsap";
import AOS from "aos";
// import ScrollTrigger from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);

export default () => {
    const nodeSelectors = {
        container: '[js-hero-animation="container"]',

        sidebar: '[js-hero-animation="sidebar"]',
        media: '[js-hero-animation="media"]',
        scrollIndicator: '[js-hero-animation="scroll-indicator"]',

        headerNav: '[js-hero-animation="header-nav"]',
        headerLogo: '[js-hero-animation="header-logo"]',
        socialMedia: '[js-hero-animation="social-media"]',
    }

    const delay = 2.4;
    const playedKey = 'heroAnimPlayed'; // sessionStorage key

    const tl = gsap.timeline({
        // paused: true,
        // reversed: true,
        // onStart: lockScroll,
        // onComplete: unlockScroll
    });

    function init() {
        if (!document.body.classList.contains('animate-hero-animation') ||
            !document.querySelector(nodeSelectors.container)) {
            return
        }

        const alreadyPlayed = sessionStorage.getItem(playedKey);
        const BREAKPOINT = 960;
        let isDesktop = window.innerWidth >= BREAKPOINT; // initial state

        window.addEventListener("resize", () => {
            if (window.innerWidth >= BREAKPOINT && !isDesktop) {
                isDesktop = true;
                location.reload();
            }
            if (window.innerWidth < BREAKPOINT && isDesktop) {
                isDesktop = false;
                location.reload();
            }
        });

        if (alreadyPlayed) {

        } else {
            window.onbeforeunload = function () {
                window.scrollTo(0, 0);
            };
        }

        // Fade out on unload
        window.onbeforeunload = function () {
            document.body.style.transition = "opacity 0.3s";
            document.body.style.opacity = "0";
        };

        // Reset opacity when page loads normally
        window.addEventListener("DOMContentLoaded", () => {
            document.body.style.opacity = "1";

            if ( $body.hasClass('home') && !isDesktop ) {
                lockScroll();
                setTimeout(() => {
                    $('.waitAnimations').removeClass('waitAnimations');
                    $('.template-part-hero .content .media').css('padding-top', '450px');
                    setTimeout(() => {
                        AOS.refresh();
                    }, 600);
                    unlockScroll();
                }, 5000)
            }

        });

        // Reset opacity when restored from bfcache
        window.addEventListener("pageshow", (event) => {
            if (event.persisted) {
                document.body.style.opacity = "1";
            }
        });

        const $body = $('body, html')

        // Hero elements
        const sidebar = document.querySelector(nodeSelectors.sidebar)
        const media = document.querySelector(nodeSelectors.media)
        const scrollIndicator = document.querySelector(nodeSelectors.scrollIndicator)

        // Header elements
        const socialMedia = document.querySelector(nodeSelectors.socialMedia)
        const logo = document.querySelector(nodeSelectors.headerLogo)
        const nav = document.querySelector(nodeSelectors.headerNav)

        // Video
        const video =
            (media && media.tagName === 'VIDEO') ? media :
                (media && media.querySelector?.('video')) || null;

        function buildTimeline() {
            if (!isDesktop) return;

            tl.to(sidebar, { width: '31%', minWidth: "370px", duration: 0.5, delay: delay }, 0)
                .to(media, { width: '69%', duration: 0.5}, delay + 0.1)
                .to(logo, { opacity: 1, duration: 0.5}, delay + 0.3)
                .to(nav, { transform: "translate(0, 0)", opacity: 1, duration: 0.3}, delay + 0.7)
                .to(socialMedia, { transform: "translate(0, 0)", opacity: 1, duration: 0.3 }, delay + 1)
                .to(scrollIndicator, { transform: "translate(0, 0)", opacity: 1, duration: 0.3}, delay + 1)
                .set([document.documentElement, document.body], { overflowY: 'auto' }, delay + 1.01);
        }

        if (alreadyPlayed) {
            // ✅ skip straight to end
            buildTimeline();
            tl.progress(1); // jump to finished state
        } else {
            // ✅ run animation once
            buildTimeline();
            waitUntilVideoPlaying(video).then(() => {
                tl.play(0);
                sessionStorage.setItem(playedKey, '1'); // mark as played
            });
        }
    }

    function waitUntilVideoPlaying(video, { timeout = 10000 } = {}) {
        if (!video) return Promise.resolve();
        if (!video.paused && !video.ended && video.readyState > 2) {
            return Promise.resolve();
        }
        return new Promise((resolve) => {
            const done = () => cleanup(resolve);
            const timer = setTimeout(done, timeout);
            const onPlaying = () => done();
            const cleanup = (cb) => {
                clearTimeout(timer);
                video.removeEventListener('playing', onPlaying);
                cb();
            };
            video.addEventListener('playing', onPlaying, { once: true });
            try { video.play?.(); } catch (_) {}
        });
    }

    function isAnimating() {
        return document.querySelector('body').classList.contains('animate-hero-animation')
    }

    function lockScroll() {
        document.documentElement.style.overflow = "hidden";
    }

    function unlockScroll() {
        document.documentElement.style.overflow = "";
    }

    return Object.freeze({
        init,
        isAnimating,
        waitUntilVideoPlaying,
        nodeSelectors
    })
}
